module.exports = __webpack_public_path__ + "img/everli_logo@1x.9312346b.png";